import React, {PureComponent} from 'react';
import classNames from 'classnames';

const clickable = ({isPast}) => !isPast;

/**
 * Stripped down version of day availability while A/B testing. Entire file be cleaned after test completion.
 * https://github.homeawaycorp.com/traveler/react-trip-details/blob/master/src/components/calendarTemplates/DayAvailability/DayAvailability.js
 */
class SameDayAvailability extends PureComponent {
    static canClick = clickable;
    static canHover = clickable;

    render() {
        const {day, isPast} = this.props;
        const dateClasses = classNames({
            date: true,
            past: isPast,
        });

        return <div className={dateClasses}>{day}</div>;
    }
}

export default SameDayAvailability;
